/* eslint-disable no-case-declarations */
/* eslint-disable indent */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef } from "react";
import { AutoComplete, Form, message } from "antd";
import API from "../../../../api";
import urls from "../../../../api/urls";

const { GET_RECIVER_NAME_ADDRESS } = urls;

export default function AutoSenderName({
  reviverNameAndAddress,
  form,
  bookType,
  disabled,
}) {
  const [options, setOptions] = useState([]);
  const [dropDownChanges, setdropDownChanges] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [isTyping, setIsTyping] = useState(false);

  useEffect(() => {
    document.querySelectorAll(".ant-select-item-option").forEach((option) => {
      option.classList.remove("ant-select-item-option-active");
    });
  }, [dropDownChanges]);

  const onSelect = (e, b) => {
    if (e == "keyDown") {
      form.setFieldsValue({
        senderAddress: b?.address?.toUpperCase(),
        senderMobileNumber: b?.mobileNumber,
        senderEmail: b?.emailAddress,
        senderGST: b?.gstNo || null,
        kycDocumentNo: b?.kycNo || null,
        kycDocumentType: b?.kycType || "AADHAAR",
      });
    } else {
      const findAddress = options?.find((obj) => obj?.userId === +b?.key);

      form.setFieldsValue({
        senderName: findAddress?.name?.toUpperCase(),
        senderAddress: findAddress?.address?.toUpperCase(),
        senderMobileNumber: findAddress?.mobileNumber,
        senderEmail: findAddress?.emailAddress,
        senderGST: findAddress?.gstNo || null,
        kycDocumentNo: findAddress?.kycNo || null,
        kycDocumentType: findAddress?.kycType || "AADHAAR",
      });

      const inputFieldId = "senderAddress";
      const targetElement = document.getElementById(inputFieldId);
      if (targetElement) {
        targetElement.focus();
        targetElement.select();
      }
    }
  };

  const handleKeyDown = (event, dataOptions, formItemName) => {
    switch (event.key) {
      case "Enter":
        onEnter(event);

        break;

      case "Tab":
        // onEnter(event);
        const activeOption = document.querySelector(
          ".ant-select-item-option-active"
        );

        if (activeOption) {
          setdropDownChanges(!dropDownChanges);
          const id = activeOption?.id;

          const optionExists = dataOptions?.find((e) => e?.userId === +id);

          if (optionExists) {
            form.setFieldsValue({
              [formItemName]: optionExists?.name?.toUpperCase(),
            });
            onSelect("keyDown", optionExists);
          }
        }
        break;

      default:
        break;
    }
  };

  function onEnter(event, name = "senderAddress") {
    event?.preventDefault();
    const targetElement__ = event?.target;
    let currentValue = targetElement__?.value?.trim();

    if (!currentValue) {
      setTimeout(() => {
        if (event?.target?.value === "") {
          form.setFields([
            {
              name: "senderName",
              errors: ["Enter sender Name"],
            },
          ]);
        }
      }, 0);

      return;
    }

    const inputFieldId = name;
    const targetElement = document.getElementById(inputFieldId);
    // console.log(targetElement, "targetElement");

    if (targetElement) {
      targetElement.focus();
      targetElement.select();
    }
  }

  const [loading, setLoading] = useState(true);

  const debounceTimerRef = useRef(null);
  const lastCallTimeRef = useRef(0);
  const { userInfo } = JSON.parse(localStorage?.getItem("userId")) || "";

  const getRecvNameAddressList = async (searchTerm) => {
    setLoading(true);

    let url = GET_RECIVER_NAME_ADDRESS + bookType;
    if (searchTerm) {
      url += `?name=${searchTerm}`;
    }

    let res = await API.Api(url).getCustomHeader({
      "PREMISE-ID": userInfo?.premiseId,
    });
    if (res.status) {
      const response = res?.response?.data;
      setOptions(
        response?.senderDetails?.map((val) => {
          return {
            ...val,
            value: val?.userId,
            key: val?.userId,
            id: val?.userId,
            label:
              (val?.name?.length > 40
                ? val?.name?.toUpperCase()?.substring(0, 40) + ".."
                : val?.name?.toUpperCase()) +
              ", " +
              (val?.address?.length > 30
                ? val?.address?.toUpperCase()?.substring(0, 30) + ".."
                : val?.address?.toUpperCase()) +
              ", " +
              val?.mobileNumber?.toString(),
            name: val?.name?.toUpperCase(),
          };
        })
      );
      setLoading(false);
    } else {
      message.error("Name list fetching error");
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const newValue = e?.target?.value || e;

    // Only make API calls if input has 3+ characters
    if (newValue.length >= 2) {
      const now = Date.now();

      if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
      }

      // Always set up the debounce timer for the final call after typing stops
      debounceTimerRef.current = setTimeout(() => {
        getRecvNameAddressList(newValue);
      }, 700);

      // If it's been at least 500ms since the last API call, make another call immediately
      if (now - lastCallTimeRef.current >= 500) {
        getRecvNameAddressList(newValue);
        lastCallTimeRef.current = now;
      }
    } else {
      // Clear suggestions if input is less than 3 characters
      setOptions([]);
    }
  };

  function onBlurHandler(params) {
    if (debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current);
      debounceTimerRef.current = null;
    }
    // Optional: hide suggestions when focus is lost
    // setOptions([]);
  }

  return (
    <Form.Item
      label="Sender name"
      id="rName"
      name="senderName"
      rules={[
        {
          required: true,
          message: "Enter receiver name",
        },
      ]}
    >
      <AutoComplete
        // defaultActiveFirstOption
        // showAction={["focus", "click"]}

        showSearch
        onKeyDown={(event) => handleKeyDown(event, options, "senderName")}
        onKeyPress={(event) => {
          if (event?.key === "Enter") {
            onEnter(event, "senderAddress");
          }
        }}
        onInput={(e) => {
          const input = e?.target;
          const cursorPosition = input?.selectionStart;
          const upperCaseValue = input?.value?.toUpperCase();
          input.value = upperCaseValue;

          input.setSelectionRange(cursorPosition, cursorPosition);
        }}
        // maxLength={100}
        onSearch={handleInputChange}
        disabled={disabled}
        onBlur={onBlurHandler}
        popupClassName="custom-auto-complete"
        onSelect={onSelect}
        placeholder="Enter sender name"
        options={options}
      ></AutoComplete>
    </Form.Item>
  );
}
